/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { FieldSize } from "./FieldSize";
export const FieldAppearance = core.serialization.object({
    size: FieldSize.optional(),
});
